import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const MapProviderDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [

  ],
  subscriptions: {

  },
  defaultColumns: [
  
  ],
  columnConfig: {

  }
}